import React from "react";
import EmbeddedForm from "modules/forms/embedded/EmbeddedForm";
import ReactDOM from "react-dom/client";
import "core/i18n";

export {};

declare global {
    interface Window {
        piggy: any,
        leat: any;
    }
}

initialize();

function initialize() {
    if (!window.piggy) {
        window.piggy = {
            form: {
                create: create
            }
        };
    }

    if (!window.leat) {
        window.leat = {
            form: {
                init: init
            }
        };
    }
}

type EmbedOptions = {
    formId: string,
    portalId?: string,
    onSubmit?: (data: any) => void,
    onError?: (error: any) => void,
    useCss?: boolean;
};

// This is old piggy way.
function create(options: EmbedOptions) {

    let portalElement;

    if (options.portalId) {
        portalElement = document.getElementById(options.portalId);
    } else {
        portalElement = document.createElement("div");
        portalElement.setAttribute("id", "piggy_form");

        if (document.body) {
            document.body.appendChild(portalElement);
        } else {
            document.appendChild(portalElement);
        }
    }

    if (!portalElement) {
        console.log({
            message: "Piggy: No DOM-element found to render into.",
            options: options,
        });

        return;
    }

    ReactDOM.createRoot(portalElement).render(<EmbeddedForm {...options} />);
}

// New Leat way
function init(options: EmbedOptions) {

    console.log("Leat: Starting form. Waiting for DomContentLoaded event to fire...");

    document.addEventListener("DOMContentLoaded", () => {

        console.log("Leat: DomContentLoaded event received.");

        if (!options.portalId) {
            console.error("Leat: No portal Id found.");

            return;
        }

        const portalElement = document.getElementById(options.portalId);

        if (!portalElement) {
            console.log({
                message: "Leat: No DOM-element found to render into.",
                options: options,
            });

            return;
        }

        console.log(`Leat: Rendering into id: "${portalElement.id}"`);

        ReactDOM.createRoot(portalElement).render(<EmbeddedForm {...options} />);
    });
}